<div class="order-request-container safe-area-inset-top safe-area-inset-bottom">
  <div class="container-fluid">
    
    <!-- Header -->
    <div class="header-section">
      <div class="card header-card">
        <div class="card-body">
          <div class="header-content">
            <button routerLink="/dashboard" class="btn-back">
              ← Volver
            </button>
            <h1 class="page-title">🍽️ Quiero Pedir</h1>
            <p class="page-subtitle">Elige cómo encontrar tu restaurante</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Method Selection -->
    <div *ngIf="!selectedMethod" class="method-selection-section">
      <h2 class="section-title">📋 Elige tu método preferido</h2>
      
      <div class="methods-grid">
        <div 
          *ngFor="let method of orderMethods"
          class="card method-card"
          [class.disabled]="!method.available"
          (click)="method.available && selectMethod(method.id)"
        >
          <div class="card-body method-content">
            <div class="method-icon">{{ method.icon }}</div>
            <div class="method-info">
              <h3 class="method-title">{{ method.title }}</h3>
              <p class="method-description">{{ method.description }}</p>
            </div>
            <div class="method-arrow" *ngIf="method.available">›</div>
            <div class="method-disabled" *ngIf="!method.available">❌</div>
          </div>
        </div>
      </div>
    </div>

    <!-- QR Scanner Method -->
    <div *ngIf="selectedMethod === 'qr'" class="method-content-section">
      <div class="card method-active-card">
        <div class="card-header">
          <div class="method-header">
            <h2>📱 Escanear Código QR</h2>
            <button (click)="resetSelection()" class="btn btn-secondary btn-sm">
              🔄 Cambiar método
            </button>
          </div>
        </div>
        
        <div class="card-body">
          <div class="qr-instructions">
            <div class="instruction-content">
              <h3>📋 Instrucciones</h3>
              <ol class="instructions-list">
                <li>Busca el código QR en la mesa del restaurante</li>
                <li>Apunta la cámara hacia el código QR</li>
                <li>Espera a que se escanee automáticamente</li>
                <li>¡Listo! Accederás al menú del restaurante</li>
              </ol>
            </div>
          </div>
          
          <div class="action-buttons">
            <button routerLink="/scanner" class="btn btn-primary btn-block btn-lg">
              📷 Abrir Cámara
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Address Input Method -->
    <div *ngIf="selectedMethod === 'address'" class="method-content-section">
      <div class="card method-active-card">
        <div class="card-header">
          <div class="method-header">
            <h2>📍 Introducir Dirección</h2>
            <button (click)="resetSelection()" class="btn btn-secondary btn-sm">
              🔄 Cambiar método
            </button>
          </div>
        </div>
        
        <div class="card-body">
          <form [formGroup]="addressForm" (ngSubmit)="onAddressSubmit()" class="address-form">
            <div class="form-group">
              <label for="address">🏢 Dirección</label>
              <input 
                type="text" 
                id="address"
                formControlName="address"
                class="form-control"
                [class.is-invalid]="addressForm.get('address')?.invalid && addressForm.get('address')?.touched"
                placeholder="Calle, número..."
              >
              <div *ngIf="addressForm.get('address')?.invalid && addressForm.get('address')?.touched" class="error-message">
                <span *ngIf="addressForm.get('address')?.errors?.['required']">La dirección es requerida</span>
                <span *ngIf="addressForm.get('address')?.errors?.['minlength']">La dirección debe tener al menos 5 caracteres</span>
              </div>
            </div>

            <div class="form-group">
              <label for="city">🏙️ Ciudad</label>
              <input 
                type="text" 
                id="city"
                formControlName="city"
                class="form-control"
                [class.is-invalid]="addressForm.get('city')?.invalid && addressForm.get('city')?.touched"
                placeholder="Madrid, Barcelona..."
              >
              <div *ngIf="addressForm.get('city')?.invalid && addressForm.get('city')?.touched" class="error-message">
                <span *ngIf="addressForm.get('city')?.errors?.['required']">La ciudad es requerida</span>
              </div>
            </div>

            <div class="form-group">
              <label for="postalCode">📮 Código Postal</label>
              <input 
                type="text" 
                id="postalCode"
                formControlName="postalCode"
                class="form-control"
                [class.is-invalid]="addressForm.get('postalCode')?.invalid && addressForm.get('postalCode')?.touched"
                placeholder="28001"
                maxlength="5"
              >
              <div *ngIf="addressForm.get('postalCode')?.invalid && addressForm.get('postalCode')?.touched" class="error-message">
                <span *ngIf="addressForm.get('postalCode')?.errors?.['required']">El código postal es requerido</span>
                <span *ngIf="addressForm.get('postalCode')?.errors?.['pattern']">Debe tener exactamente 5 números</span>
              </div>
            </div>

            <button 
              type="submit" 
              class="btn btn-primary btn-block btn-lg"
              [disabled]="addressForm.invalid || loading"
            >
              <span *ngIf="loading">⏳ Buscando...</span>
              <span *ngIf="!loading">🔍 Buscar Restaurantes</span>
            </button>
          </form>
        </div>
      </div>
    </div>

    <!-- GPS/Location Method -->
    <div *ngIf="selectedMethod === 'gps'" class="method-content-section">
      <div class="card method-active-card">
        <div class="card-header">
          <div class="method-header">
            <h2>🗺️ Restaurantes Cercanos</h2>
            <button (click)="resetSelection()" class="btn btn-secondary btn-sm">
              🔄 Cambiar método
            </button>
          </div>
        </div>
        
        <div class="card-body">
          <!-- Loading State -->
          <div *ngIf="loading" class="loading-state">
            <div class="loading-content">
              <div class="loading-spinner"></div>
              <h3>📡 Obteniendo tu ubicación...</h3>
              <p>Por favor, permite el acceso a la ubicación</p>
            </div>
          </div>

          <!-- Location Found -->
          <div *ngIf="!loading && currentPosition" class="location-found">
            <div class="location-info">
              <h3>📍 Tu ubicación actual</h3>
              <p class="coordinates">
                Lat: {{ currentPosition.coords.latitude | number:'1.6-6' }}, 
                Lng: {{ currentPosition.coords.longitude | number:'1.6-6' }}
              </p>
              <p class="accuracy">Precisión: {{ currentPosition.coords.accuracy | number:'1.0-0' }} metros</p>
            </div>

            <!-- Nearby Restaurants -->
            <div class="nearby-restaurants">
              <h3>🍽️ Restaurantes Cercanos</h3>
              <div class="restaurants-list">
                <div 
                  *ngFor="let restaurant of nearbyRestaurants" 
                  class="card restaurant-card"
                  (click)="onRestaurantSelect(restaurant)"
                >
                  <div class="card-body restaurant-content">
                    <div class="restaurant-info">
                      <h4 class="restaurant-name">{{ restaurant.name }}</h4>
                      <p class="restaurant-address">{{ restaurant.address }}</p>
                      <div class="restaurant-meta">
                        <span class="cuisine-type">{{ restaurant.cuisineType }}</span>
                        <span class="distance">{{ restaurant.distance }}</span>
                      </div>
                      <div class="restaurant-stats">
                        <span class="rating">{{ getStars(restaurant.rating) }} {{ restaurant.rating }}</span>
                        <span class="estimated-time">⏱️ {{ restaurant.estimatedTime }}</span>
                      </div>
                    </div>
                    <div class="restaurant-arrow">›</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Error/No Location -->
          <div *ngIf="!loading && !currentPosition" class="no-location">
            <div class="no-location-content">
              <h3>❌ No se pudo obtener tu ubicación</h3>
              <p>Por favor, asegúrate de que el GPS esté activado y permite el acceso a la ubicación.</p>
              <button (click)="getCurrentLocation()" class="btn btn-primary btn-lg">
                🔄 Intentar de nuevo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Help Section -->
    <div class="help-section">
      <div class="card help-card">
        <div class="card-body">
          <h3 class="help-title">💡 ¿Necesitas ayuda?</h3>
          <div class="help-content">
            <div class="help-item">
              <span class="help-icon">📱</span>
              <div class="help-text">
                <strong>QR:</strong> Ideal si estás en el restaurante y ves el código QR
              </div>
            </div>
            <div class="help-item">
              <span class="help-icon">📍</span>
              <div class="help-text">
                <strong>Dirección:</strong> Perfecto si sabes exactamente dónde quieres pedir
              </div>
            </div>
            <div class="help-item">
              <span class="help-icon">🗺️</span>
              <div class="help-text">
                <strong>GPS:</strong> Encuentra opciones cerca de tu ubicación actual
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
